import { useShallow } from "zustand/react/shallow";
import { useScoreFetchingStore } from "../../../../store/scoreFetchingStore";
import { useUserStore } from "../../../../store/userStore";
import FetchingProgressBar from "./_partials/FetchingProgressBar";
import { useProfileId } from "../../../../hooks/useProfileId";
import { useUserSelectStore } from "../../../../store/store";
import OutlineQuestionMarkIcon from "../../../../components/Icons/OutlineQuestionMarkIcon";
import YearSelect from "./_partials/YearSelect";
import DownloadIcon from "../../../../components/Icons/DownloadIcon";

const ScoresFetching = () => {
  const isLoggedIn = useUserStore(useShallow((state) => state.isLoggedIn));
  const userId = useProfileId();
  const isFetchingScores = useScoreFetchingStore(
    useShallow((state) => state.isFetchingScores)
  );
  const fetchingResults = useScoreFetchingStore(
    useShallow((state) => state.results)
  );

  const errors = fetchingResults.filter((x) => x.isSuccess === false);

  const _fetchUserScores = useScoreFetchingStore(
    (state) => state.fetchUserScores
  );

  const fetchUserScores = () => {
    const gamemode = useUserSelectStore.getState().gamemode;
    const variant = useUserSelectStore.getState().variant;
    _fetchUserScores(userId, gamemode, variant);
  };

  const downloadLogs = () => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([JSON.stringify(fetchingResults)]));
    a.setAttribute("download", "scoreFetchingLogs.txt");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    // TODO: marginBottom is temporary solution so the fetching scores wouldnt just stick to the bottom of the page
    //decide what do later
    <div data-html2canvas-ignore="true" style={{ marginBottom: 200 }}>
      <h4 className="mx-3 text-white">
        Fetch scores:{" "}
        <span
          data-toggle="tooltip"
          data-placement="right"
          title={`Due to osu!api limitations you need to manually fetch scores for each beatmap.\n\nThese scores are then saved in completionist!db for usage on site.`}
        >
          <OutlineQuestionMarkIcon height={20} width={20} />
        </span>
      </h4>
      <div
        className="d-flex justify-content-center my-2"
        data-html2canvas-ignore="true"
      >
        {isFetchingScores && <FetchingProgressBar />}
      </div>
      <div
        className="d-flex justify-content-center"
        data-html2canvas-ignore="true"
      >
        <button
          className="btn btn-primary my-2"
          disabled={!isLoggedIn || isFetchingScores}
          onClick={() => fetchUserScores()}
        >
          Fetch user scores
        </button>
        <YearSelect />
      </div>
      {isFetchingScores && (
        <div className="mx-3" style={{}}>
          <div
            className="my-2"
            style={{ display: "flex", flex: 1, flexDirection: "row" }}
          >
            <span style={{ color: "white", fontSize: 24 }}>Logs:</span>
            <button
              onClick={downloadLogs}
              className="btn btn-secondary"
              style={{ marginLeft: "auto" }}
            >
              <DownloadIcon />
            </button>
          </div>
          <div
            style={{
              backgroundColor: `rgba(128,128,128,0.3)`,
              borderRadius: 10,
              padding: 20,
            }}
          >
            <p style={{ color: "white" }}>
              Success: {fetchingResults.length - errors.length}
            </p>
            <p style={{ color: "white" }}>Error: {errors.length}</p>
            {errors.length > 30
              ? "Too much errors to show"
              : errors.map((x) => {
                  if ("error" in x.apiResult)
                    return (
                      <p style={{ color: "white" }}>internal server error</p>
                    );
                  return x.apiResult.responseCodes
                    .filter((x) => x.responseStatus !== 200)
                    .map((resp) => (
                      <p style={{ color: "white" }}>
                        beatmapId: {resp.beatmapId}, code: {resp.responseStatus}
                      </p>
                    ));
                })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ScoresFetching;
